/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Type_Property_MessageInputs */

const cs_gdpr_type_property_message = /** @type {(inputs: Gdpr_Type_Property_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poptávka`)
};

const en_gdpr_type_property_message = /** @type {(inputs: Gdpr_Type_Property_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inquiry`)
};

/**
* | output |
* | --- |
* | "Inquiry" |
*
* @param {Gdpr_Type_Property_MessageInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_type_property_message = /** @type {((inputs?: Gdpr_Type_Property_MessageInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Type_Property_MessageInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_type_property_message(inputs)
	return cs_gdpr_type_property_message(inputs)
});